export default __webpack_public_path__ + "static/media/144.07aefd3c.png";